let pageType : string = "";

export class PageTypeService {
    public static setPageType(value : string) {
        pageType = value;
    }

    public static getPageType() {
        return  pageType;
    }
}